<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-input
          v-model="getUserTargetBtChildrenList_data.umName"
          placeholder="请输入名称"
          clearable
          size='small'
          style="max-width:380px;"/>
        <el-button
          v-click.getUserTargetBtChildrenList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
      <el-col :span="6" >
        <el-button v-if="addUserTarget"
          @click=" $form('addUserTarget'),getBusinessTypeList(),getProjectUserLevelList() "
          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >添加训战目标
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getUserTargetBtChildrenList'
      api='getUserTargetBtChildrenList'
      updateapi='updateCircleLetter'
      :height="H-165" >
    </mytable> 

    <myform
      :viewobj='{
        addUserTarget:    [ "新增训战目标信息", "el-icon-circle-plus" ],
        updateUserTarget: [ "修改训战目标信息", "el-icon-edit-outline"],
        $succeed$: getUserTargetBtChildrenList
      }'
      @close='$form("addUserTarget","reset")' >
      <hide slot='utId' />
      <!-- 战队id -->
      <template v-slot:dtId="{Myformdata}" >
  		 
  	  </template>
      <!-- 业务类型 -->
      <template v-slot:btId="{Myformdata}" >
        <el-select v-model='Myformdata.btId' clearable>
            <el-option
                v-for="item in getBusinessTypeList_data.data||[]"
                :key="item.btId"
                :label="item.btName"
                :value="item.btId">
            </el-option>
        </el-select>
  	  </template>
      <!-- 人员id -->
      <template v-slot:userId="{Myformdata}" >
        <el-select v-model='Myformdata.userId' clearable>
            <el-option
                v-for="item in getProjectUserLevelList_data.data||[]"
                :key="item.userId"
                :label="item.userName"
                :value="item.userId">
            </el-option>
        </el-select>
  	  </template>
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {

      tableColums_getUserTargetBtChildrenList: {
        $selection: false,

        utType: ['类型',,'@v-if: 1:战队, 2:学员'],

        utStatus: ['类型',,'@v-if: 1:未完成, 2:已完成'],

          dtName: '分公司',

        userName: '学员',

        utTarget: '目标量',

        utComplete: '完成量',

        dtLevel: ['战队等级', 100, '@v-if: 1:省级战队#warn, 2:市级战队#warn, 3:区级战队#warn, 4:网格#warn' ],

        utNumType: ['目标类型', 100, '@v-if: 1:签约家数#warn, 2:签约数量#warn, 3:签约金额#warn' ],

        utCompleteTime: '完成时间',

        createtime: '创建时间',
        
        $operation: [
          '操作', 200,
          this.updateUserTarget && `@text: 编辑#success
           @click: $form("updateUserTarget",$row)
          `,
          this.deleteUserTarget && `@text: 删除#danger
           @click: _confirm('确定要删除该训战目标吗?')
                   .trigger('deleteUserTarget',{utId:$row.utId})
                   .trigger('getUserTargetBtChildrenList')
          `,
        ],
      },

    };
  },

  watch: {
    
  },

  methods: {},

  created() {
    this.getUserTargetBtChildrenList();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/User/UserTargerMine copy.vue